var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnfav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1044_1630)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 39,
    height: 38,
    rx: 16.7725,
    fill: "#9F49AE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 38,
    height: 37,
    rx: 16.2725,
    stroke: "url(#paint0_linear_1044_1630)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 15.3543L20.0724 15.7659C20.1278 15.8234 20.1942 15.8691 20.2677 15.9003C20.3411 15.9316 20.4201 15.9476 20.4999 15.9476C20.5797 15.9476 20.6587 15.9316 20.7322 15.9003C20.8056 15.8691 20.872 15.8234 20.9274 15.7659L20.4999 15.3543ZM16.5424 23.9993C16.4206 23.8991 16.264 23.8515 16.1071 23.8667C15.9502 23.882 15.8057 23.959 15.7056 24.0808C15.6054 24.2026 15.5578 24.3592 15.5731 24.5161C15.5883 24.673 15.6653 24.8175 15.7871 24.9176L16.5424 23.9993ZM12.854 21.6172C12.8914 21.6856 12.942 21.7459 13.0027 21.7948C13.0635 21.8437 13.1333 21.8801 13.2081 21.902C13.2829 21.9239 13.3614 21.9309 13.4389 21.9225C13.5164 21.9141 13.5915 21.8905 13.6599 21.8531C13.7283 21.8156 13.7887 21.7651 13.8376 21.7044C13.8864 21.6436 13.9229 21.5738 13.9448 21.499C13.9667 21.4241 13.9736 21.3457 13.9652 21.2682C13.9568 21.1907 13.9333 21.1156 13.8958 21.0472L12.854 21.6172ZM13.177 18.2336C13.177 16.5315 14.1389 15.1033 15.4523 14.5024C16.7284 13.919 18.4432 14.0734 20.0724 15.7659L20.9274 14.9434C18.9958 12.9349 16.7506 12.6032 14.9583 13.4226C13.2055 14.2246 11.9895 16.0866 11.9895 18.2336H13.177ZM17.7267 26.4376C18.1328 26.7574 18.5683 27.0979 19.0092 27.3559C19.4502 27.6132 19.9537 27.823 20.4999 27.823V26.6355C20.2545 26.6355 19.9663 26.5405 19.6085 26.3307C19.2499 26.1217 18.8786 25.8336 18.4622 25.505L17.7267 26.4376ZM23.2731 26.4376C24.402 25.547 25.846 24.5273 26.9781 23.2519C28.1316 21.9536 29.0103 20.3442 29.0103 18.2336H27.8228C27.8228 19.9737 27.1103 21.3139 26.0907 22.4634C25.0496 23.6351 23.7378 24.559 22.5377 25.505L23.2731 26.4376ZM29.0103 18.2336C29.0103 16.0866 27.7951 14.2246 26.0416 13.4226C24.2493 12.6032 22.0057 12.9349 20.0724 14.9426L20.9274 15.7659C22.5567 14.0742 24.2714 13.919 25.5476 14.5024C26.861 15.1033 27.8228 16.5307 27.8228 18.2336H29.0103ZM22.5377 25.505C22.1213 25.8336 21.75 26.1217 21.3913 26.3307C21.0335 26.5397 20.7453 26.6355 20.4999 26.6355V27.823C21.0462 27.823 21.5497 27.6132 21.9906 27.3559C22.4324 27.0979 22.867 26.7574 23.2731 26.4376L22.5377 25.505ZM18.4622 25.505C17.832 25.0087 17.1915 24.5337 16.5424 23.9993L15.7871 24.9176C16.4442 25.4583 17.1393 25.9745 17.7267 26.4376L18.4622 25.505ZM13.8958 21.0479C13.4189 20.1869 13.1714 19.2178 13.177 18.2336H11.9895C11.9895 19.5303 12.322 20.6442 12.854 21.6172L13.8958 21.0479Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1044_1630",
    x: 0.6,
    y: 0.6,
    width: 39.8,
    height: 38.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.329412 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1044_1630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1044_1630",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1044_1630",
    x1: 23.8833,
    y1: 39,
    x2: 12.8146,
    y2: 7.26201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F4981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfav);
export default __webpack_public_path__ + "static/media/unfav.59214fbd11f9c0e065857f5ba1fcb600.svg";
export { ForwardRef as ReactComponent };